import { h } from 'preact';
import { Text } from 'preact-i18n';
import style from './style';
import cx from 'classnames';

export default function LoadingText({ color, ...props }) {
	return (
		<span {...props} class={cx(style.loading, style[color], props.class)}>
			<Text id="loading" />
		</span>
	);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/loading-text/index.js